import React, { Fragment } from 'react';
import Collapsible from 'react-collapsible';
import ContainerHeader from 'components/ContainerHeader';
import FeatureDetailTable from '../featureDetailTable';


const FeatureDependency = ({ dependencies, title }) => {
    if (dependencies && Array.isArray(dependencies) && dependencies.length > 0) {
        return (
            <Fragment>
                <ContainerHeader title={title} />
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-12">
                        {dependencies.map((dependency, index) => {
                            return (
                                <Collapsible trigger={dependency?.name} key={index} triggerStyle={{afterTop: 2, backgroundColor: 'black', paddingTop: 8, paddingBottom: 8}}>
                                    <div className="col-sm-12 text-center text-sm-left">
                                        <FeatureDetailTable displayData={dependency} />
                                    </div>
                                </Collapsible>
                            );
                        })}
                    </div>
                </div>
            </Fragment>
        );
    } else {
        return (
            <div className="row">
                <div className="col-md-12 col-12">
                    <Fragment>
                        <ContainerHeader title={title} />
                        <div className="mr-auto">
                            <h3 className="card-heading">No dependencies found here</h3>
                        </div>
                    </Fragment>
                </div>
            </div>
        );
    }
};

export default FeatureDependency;


// WEBPACK FOOTER //
// ./components/Agile/feature/featureDetail/featureDependency/index.js